<template>
    <div class="book-home" style="border-style: none;">
      <article class="about  active" data-page="about">
      <header>
          <h2 class="h2 article-title">Book List</h2>
      </header>
      <BookHeader
        v-for="book in books" 
        :key="book.id" 
        :id="book.id"
        :title="book.title" 
        :bookCover="book.coverImage"
        :authorName="book.author.name"
        :tags="book.tags"
        style="border-style: solid;background: var(--border-gradient-onyx);border-radius: 5px;
        padding: 5px;"
      />
    </article>
    </div>
  </template>
  
  <script>
 
import books from '@/data/books'
import BookHeader from '../components/BookHeader.vue';
  
  export default {
    name: 'BookListPage',
    components: {
        BookHeader
    },
    data() {
      return {
        books
      }
    }
  }
  </script>
  
  <!-- // Basic Styling (you can move this to a separate CSS file) -->
  <style>
  .book-post {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    margin-bottom: 20px;
    /* border-style: inset; */
  }
  
  .book-cover {
    max-width: 100px;
    max-height: 150px;
    height: auto;
    border-color: #ffc562;
    border-width: 2px;
    border-style: inset;
  }
  
  .author-image {
    max-width: 100px;
    max-height: 150px;
    height: auto;
    border-radius: 25%;
    border-color: #ffc562;
    border-width: 2px;
    border-style: inset;
  }
  
  .book-tags .tag {
    background-color: #f0f0f0;
    padding: 5px 10px;
    margin-right: 10px;
    border-radius: 15px;
  }
  </style>
  
  